export default "__VITE_ASSET__9yda4enQ__"